/**
 * TableSkeleton — shimmer loading skeleton that mirrors the resident table layout.
 * Renders 8 placeholder rows with column-width blocks.
 */
const SkeletonRow = () => (
  <tr className="rp-skeleton-row">
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '1rem' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '6rem' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '6rem' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '5rem' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '4rem' }} /></td>
    <td className="rp-skeleton-td">
      <div className="rp-skeleton-groups">
        <div className="rp-skeleton-block" style={{ height: '1.25rem', width: '3.5rem', borderRadius: '0.375rem' }} />
        <div className="rp-skeleton-block" style={{ height: '1.25rem', width: '3.5rem', borderRadius: '0.375rem' }} />
      </div>
    </td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1.25rem', width: '4rem', borderRadius: '9999px' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '5rem' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1.25rem', width: '4rem', borderRadius: '9999px' }} /></td>
    <td className="rp-skeleton-td"><div className="rp-skeleton-block" style={{ height: '1rem', width: '1rem' }} /></td>
  </tr>
);

const TableSkeleton = () => {
  return (
    <div className="rp-skeleton-wrap">
      <table className="rp-skeleton-table">
        <thead className="rp-skeleton-thead">
          <tr>
            {['', 'First Name', 'Last Name', 'Area', 'Area Type', 'Groups', 'Devices', 'Last Check-in', 'Status', ''].map(
              (label, i) => (
                <th key={i} className="rp-skeleton-th">
                  {label ? (
                    <div className="rp-skeleton-block--header" style={{ height: '0.875rem', width: `${label.length * 7}px` }} />
                  ) : (
                    <div className="rp-skeleton-block--header" style={{ height: '1rem', width: '1rem' }} />
                  )}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody className="rp-skeleton-tbody">
          {Array.from({ length: 8 }).map((_, i) => (
            <SkeletonRow key={i} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
